var exports = {
  "Lw": "x93eb46d8--1642e5--overlay",
  "Qs": "x93eb46d8--1642e5--content",
  "rJ": "x93eb46d8--1642e5--content_half-screen",
  "b_": "x93eb46d8--1642e5--content_hidden",
  "o5": "x93eb46d8--1642e5--content-wrapper",
  "uy": "x93eb46d8--1642e5--content-wrapper_css-height",
  "JI": "x93eb46d8--1642e5--content-wrapper_fixed-header",
  "xR": "x93eb46d8--1642e5--content-wrapper_half-screen",
  "wx": "x93eb46d8--1642e5--header",
  "JO": "x93eb46d8--1642e5--header_reduced",
  "_R": "x93eb46d8--1642e5--close-button",
  "iW": "x93eb46d8--1642e5--main",
  "HV": "x93eb46d8--1642e5--main_fixed-header",
  "qr": "x93eb46d8--1642e5--footer",
};

module.exports = exports;
